import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import LocationIcon from '../../../../new-components/svg-icons/LocationIcon';
import CallIcon from '../../../../new-components/svg-icons/CallIcon';
import ClockIcon from '../../../../new-components/svg-icons/ClockIcon';
import { useSelector } from 'react-redux';
import { getPhoneNumber } from '../../../../helpers/common';
import { logEvent } from '../../../../new-lib/analytics';

export default function ReachUs() {
  const { t } = useTranslation(['contact', 'common']);
  const referer = useSelector((state: any) => state.app.referer);
  const PHONE_NUMBER = '01065888849';
  const HOTLINE_NUMBER = '15812';
  const eventId = useSelector((state: any) => state.app.eventId);
  return (
    <Container>
      <div className="reach-us">
        <div className="reach-child">
          <div className="reach-icon">
            <LocationIcon />
          </div>
          <div className="reach-detail">
            <h2 className="headline-3">{t('address')}</h2>
            <p className="text-1">{t('head_quarters_address')}</p>
            <p className="text-1">{t('october_address')}</p>
          </div>
        </div>

        <div className="reach-child">
          <div className="reach-icon">
            <CallIcon />
          </div>

          <div className="reach-detail">
            <h2 className="headline-3">{t('contacts')}</h2>
            <a
              className="text-1"
              href={`tel:+2${PHONE_NUMBER}`}
              onClick={() => logEvent.contact('call', 'ContactPage', eventId)}
            >
              <p dir="ltr">+2{PHONE_NUMBER}</p>
            </a>
            <a
              className="text-1"
              href={`tel:${HOTLINE_NUMBER}`}
              onClick={() => logEvent.contact('call', 'ContactPage', eventId)}
            >
              <span>{t('hotline')}</span>
              <span dir="ltr">{HOTLINE_NUMBER}</span>
            </a>
            <a
              className="text-1"
              href="mailto:info@nawy.com"
              onClick={() => logEvent.contact('email', 'ContactPage', eventId)}
            >
              <p>info@nawy.com</p>
            </a>
          </div>
        </div>

        <div className="reach-child">
          <div className="reach-icon">
            <ClockIcon />
          </div>
          <div className="reach-detail">
            <h2 className="headline-3">{t('working_hours')}</h2>
            <p className="text-1">{t('sunday_thursday')}</p>
            <p className="text-1">{t('hours')}</p>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 100px;
  .reach-us {
    display: flex;
    flex-direction: column;
    margin-top: 35px;
    .reach-child {
      display: flex;
      flex-direction: row;
      gap: 16px;
      margin-bottom: 18px;
      .reach-icon {
        svg {
          width: 25px;
          height: auto;
          path {
            fill: ${props => props.theme.light.colors.darkGrey};
          }
        }
      }

      .reach-detail {
        h2 {
          color: ${props => props.theme.light.colors.black};
          margin-bottom: 5px;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }
`;
